// globalVariable.js veya benzeri bir dosyanız
import { clearAllTokens } from '@/services/auth';

const isLocalhost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

const API_URL = isLocalhost
    ? 'http://localhost/byc-takip/api/'
    : 'https://takip.gifadwork.com/api/';

export const globalVariable = {
    apiUrl: API_URL,
    varsayilanGorsel: function(event) {
        event.target.src = this.apiUrl + 'resources/varsayilan.png';
    },
    isValidDateFormat: function(tarih) {
        // Düzenli ifade ile format kontrolü
        const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
        return regex.test(tarih);
    },
    setRouter: function(router) {
        this.router = router;
    },
    cikisYap: function() {
        clearAllTokens();
        this.router.push({ name: 'Login' });
    },
};

globalVariable.uploadUrl = globalVariable.apiUrl + 'uploads/';

// Türkçe kısa tarih formatı: 2 Kasım 12:50
export function formatTarihKisa(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString.replace(' ', 'T'));
  if (isNaN(date.getTime())) return '';
  const aylar = [
    'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
    'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
  ];
  const gun = date.getDate();
  const ay = aylar[date.getMonth()];
  const saat = date.getHours().toString().padStart(2, '0');
  const dakika = date.getMinutes().toString().padStart(2, '0');
  const yil = (date.getFullYear() !== new Date().getFullYear()) ? ` ${date.getFullYear()}` : '';
  return `${gun} ${ay}${yil} ${saat}:${dakika}`;
}


